import { z } from 'zod';
import { makeEvent } from './EventBase';
import { PaymentAttempt } from '@/api';

export const PaymentAttemptUpdated = makeEvent(
    'PaymentAttemptUpdated',
    z.object({
        data: PaymentAttempt,
    }),
);

export type PaymentAttemptUpdated = (typeof PaymentAttemptUpdated)['schema']['_output'];
